import React, { Component } from 'react';
import { useState } from 'react';
import * as CopyToClipboard from 'react-copy-to-clipboard';
import { CommaSeprator, convertIntoLakh } from '../UtilityComponent/UtilityFunction';
import { NewDateToDDMMYYYY } from './utils';

const PropHead = ({ Req }) => {
    const [copyText, setCopyText] = useState(false);
    const handleCopy = () => {
        setCopyText(true);
        setTimeout(() => setCopyText(false), 2000);
    };
    console.log(Req, "quoteReq")


    const formatCustomDate = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString);

        const day = date.getDate();
        const month = date.toLocaleString('en-US', { month: 'short' }); // Nov
        const year = date.getFullYear();

        // Add ordinal suffix
        const getSuffix = (d) => {
            if (d > 3 && d < 21) return "th";
            switch (d % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        };

        return `${day}${getSuffix(day)} ${month} ${year}`;
    };

    return (
        <div class="HealthProUpdMain">
            <div class="HealthProUpdBox01">
                <img id="companylogo" src={Req?.BuyNow?.LogoURL} alt="" />
                <h1 id="planname" class="ng-binding">{Req?.BuyNow?.PlanName}</h1>
                <p class="enqueryNumber">
                    <div class="label">Enquiry#</div>
                    <div class="value">
                        <strong class="ng-binding">
                            <CopyToClipboard text={Req?.BuyNow?.EnquiryNo} onCopy={handleCopy}>
                                <span>{Req?.BuyNow?.EnquiryNo} <i className="far fa-clone hide-this-in-pdf"></i></span>
                            </CopyToClipboard>
                            {copyText && <div className="Enq_popup">Copied!</div>}
                        </strong>
                    </div>
                </p>
            </div>
            <div className="IndemnitySilver">
                <div className="IndemnitySilverCard">
                    <div className="Indemnity_Details Indemnity_Deprap">
                        <span className="Datailsbotm" >Net Premium</span>
                        <span className="Datailsbotm-sub">₹ {Req?.BuyNow?.NetPremium}</span>
                    </div>
                    <div className="Indemnity_Details Indemnity_Deprap">
                        <span className="Datailsbotm" >+ GST (18%)</span>
                        <span className="Datailsbotm-sub">₹ {Req?.BuyNow?.ServiceTax}</span>
                    </div>
                    <div className="Indemnity_DetailList Indemnity_Total">
                        <span className="Datailsbotm" >Total Premium</span>
                        <span className="Datailsbotm-sub">₹ {CommaSeprator(Math.round(Req?.BuyNow?.TotalPremium))}</span>
                    </div>
                </div>
            </div>
            <div class="HealthProUpdBox">
                <div class="HealthProUpdVal">
                    <p> Sum Insured <span id="SumInsuredData"> &#x20B9; {convertIntoLakh(Req?.BuyNow?.SumInsured)} </span> </p>
                    <p> Policy Term <span id="Term" class="ng-binding"> 1 Year </span> </p>
                </div>
                <div class="HealthProUpdVal">
                    <p> Policy Start Date <span id="PolicyStartDateProposal" class="ng-binding"> {NewDateToDDMMYYYY(Req?.BuyNow?.PolicyStartDate && new Date(Req.BuyNow.PolicyStartDate).toLocaleDateString())} </span> </p>
                    <p> Policy End Date <span id="PolicyStartDateProposal" class="ng-binding"> {NewDateToDDMMYYYY(Req?.BuyNow?.PolicyEndDate && new Date(Req.BuyNow.PolicyEndDate).toLocaleDateString())} </span></p>
                </div>
            </div>
        </div>
    );
}
export default PropHead;
